module.exports = __webpack_public_path__ + "static/media/ic_checkbiometric.ad818708.svg";